import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { useSelector } from "react-redux";
import { getQueryParams, ObjTest } from '../../util/common';
import { BackLeftIcon } from '../../component/icon/Icon';
import { constantConfig } from 'web-common';
import { queryMenuContentList } from '../../store/action';
import { NoticeItemVo, NOTICE_INIT_STATE } from './config/interface';

import './style/noticeInfo.less';


const noticPCTopbanner = require('../../assets/images/conactUs/noticPCTopbanner.jpg');
const noticPCBottombanner = require('../../assets/images/conactUs/noticPCBottombanner.jpg');

const noticMOBILETopbanner = require('../../assets/images/conactUs/noticMOBILETopbanner.jpg');

const { ModuleTypeEnum, WEBSITE_PATHS } = constantConfig;


/**
 * 联系我们----单个公告
 */
const NoticeInfo = () => {

    const { index } = getQueryParams();

    const { isMobile } = useSelector((state: any) => state.reducer); 

    const history = useHistory();

    // 公告列表
    const [noticeList, setNoticeList] = useState<NoticeItemVo[]>([]);
    // 默认的显示的公告
    const [activeNotice, setActiveNotice] = useState<NoticeItemVo>(NOTICE_INIT_STATE);
    // 默认的下标
    const [activeIndex, setActiveIndex] = useState<number>(0);


    useEffect(() => {
		initContentList();
	}, []);


    useEffect(() => {
        // 处理从外部跳转过来，带下标的
        if (ObjTest.isNotEmptyArray(noticeList) && index >= 0) {
            if (noticeList[index]) {
                setActiveIndex(index);
                setActiveNotice(noticeList[index]);
            }
        }
    }, [index, noticeList]);


	/**
	 * 初始化公司列表
	 */
	const initContentList = async () => {
		const result = await queryMenuContentList(ModuleTypeEnum.NOTICE);
		const arrs = result.data || [];
		if (Array.isArray(arrs)) {
			setNoticeList(arrs);
            // 设置默认
            if (!activeNotice.title && arrs[0]) {
                setActiveNotice(arrs[0]);
                setActiveIndex(0);
            }
		}
	};


    /**
     * 上一篇和下一篇切换
     * @param num 
     */
    const handleActiveChange = (num: number) => {
        const tempActiveNotice = noticeList[num];
        if (tempActiveNotice) {
            setActiveIndex(num);
            setActiveNotice(tempActiveNotice);
        }
    };


    // 上一篇
    const prevItem = activeIndex > 0 ? noticeList[activeIndex - 1] : null;
    // 下一篇
    const nextItem = noticeList[activeIndex + 1] || null;


    return (
        <div className="company-contactUs-noticItem-wrapper">
            <div className="banner w ofh">
                <img src={isMobile ? noticMOBILETopbanner : noticPCTopbanner} loading="lazy" className="w" />
                <div className="banner-title">
                    <div className={isMobile ? "f32" : "f64"}>联系我们</div>
                    <div><BackLeftIcon className="back-icon" title="返回上一页" onClick={() => history.replace(WEBSITE_PATHS.noticeList)} /></div>
                </div>
            </div>
            <div className="notic">
                <div className="task">
                    <div className={isMobile ? "f18" : "f36"}>{activeNotice.title}</div>
                    <div className="pt12">
                        <span>发布者：{activeNotice.publisher}</span>
                        <span className="pl32">时间：{activeNotice.publishDate}</span>
                    </div>
                </div>
                <div 
                    style={{padding: isMobile ? "40px 16px" : "80px 28%"}}
                    dangerouslySetInnerHTML={{ __html: activeNotice.content || '' }} 
                />
            </div>
            <div className="notice-footer-banner ofh">
                <img src={noticPCBottombanner} loading="lazy" className={isMobile ? "imagec" : "w"} />
                <div className="pagination">
                    <div>
                        <Button className="p0" type="link" disabled={prevItem ? false : true} onClick={() => handleActiveChange(activeIndex - 1)}>
                            上一篇：{ prevItem ? prevItem.title : '无' }
                        </Button>
                    </div>
                    <div>
                        <Button className="p0" type="link" disabled={nextItem ? false : true} onClick={() => handleActiveChange(activeIndex + 1)}>
                            下一篇：{ nextItem ? nextItem.title: '无' }
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};


export { NoticeInfo };